
const ComingSoon = () =>{
    return(
        <div style={{display:"flex", width:"100%", height:"100dvh", justifyContent:"center", alignItems:"center"}}>
            <img src="/assets/homepage/slimeville_logo.png" style={{width:"50%"}}/>
        </div>
    );
}

export default ComingSoon;